import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings_/territories/$territoryId/drivers')({
  beforeLoad: ({ context, params }): void => {
    if (context.permissions.isReady && !context.permissions.hasPermission('drivers:list')) {
      throw redirect({ params: { territoryId: params.territoryId }, to: '/settings/territories/$territoryId' });
    }
  },
  component: lazyRouteComponent(() =>
    import('&/features/settings/drivers/pages/territory-drivers-page').then((m) => ({
      default: m.TerritoryDriversPage,
    })),
  ),
  staticData: { titleKey: 'drivers' },
});
